<template lang="pug">
//- FILTERS
.filters-wrapper

    button.btn-simple.small.btn-table-filters(
        :class="{'is-active': displayFilters}"
        title="Display filters"
        @click="toggleDisplayFilters()"
    )
        svg-icon(name='filter' size='small')

    
    .filters-wrapper-list(v-if="displayFilters")

        //- targets
        .filters-wrapper-list_top(v-if='filters.length')
            .filter-item-wrapper.l-flex-row(v-for='filter in filters', :key='filter.key')
                .filter-item.filter-status
                    .filter-label(v-on='filter.type !== "singleSelect" ? { click: () => handleClick(filter.key) } : {}')
                        svg-icon(v-if="!filter.hideIcon" :name='filter.icon.name', :size='filter.icon.size')
                        .filter-text {{ filter.label }}
                    select.filter-select(v-if='filter.type === "singleSelect"')(@change='handleFilter("update", filter)', v-model='filterTarget[filter.key]')
                        option(v-for='target in filter.targets', :key='target.value', :value='target.value') {{ target.label }}

                    WMultiselect(
                        v-else-if='filter.type === "multiSelect" && openedFilter === filter.key',
                        :filter='filter',
                        :activeFilters='activeFilters',
                        @closeSelection='closeSelection',
                        @multiselection='handleFilter'
                    )

                    WSearchable(
                        v-else-if='filter.type === "searchable" && openedFilter === filter.key',
                        :filter='filter',
                        :activeFilters='activeFilters',
                        :searchResults='searchResults',
                        @closeSelection='closeSelection',
                        @multiselection='handleFilter',
                        @termToResearch='handleTermToResearch'
                    )

        //-Dates
        .filters-wrapper-list_btm.l-flex-row--between(v-if='dateFilters.length !== 0')
            .l-flex-row
                .filter-item-wrapper.l-flex-row(v-for='dateFilter in dateFilters', :key='dateFilter.key')
                    //- extra calendars
                    .filter-item.filter-date
                        .filter-label
                            svg-icon(:name='dateFilter.icon.name', :size='dateFilter.icon.size')
                            .filter-text {{ dateFilter.from.label }}
                        .filter-date-combo.l-flex-row
                            select.select-operator(v-model='operators[dateFilter.key]', @change='handleDateFilterOperator(dateFilter.key, $event)')
                                option(v-for='operator in filterDateOperators', :key='operator.value', :value='operator.value') {{ operator.label }}
                            el-date-picker(
                                type='date',
                                v-model='dateFiltersVModelFromValues[dateFilter.key]',
                                @change='handleFromDate(dateFilter.key, $event)',
                                :placeholder='dateFilter.from.placeholder',
                                :picker-options='{disabledDate: (time) => disabledpickerOptionsFromDate(time,dateFilter.key)}'
                            )
                            //-
                            .filter-date-to(v-if='displayTo[dateFilter.key]')
                                .filter-text-to {{ dateFilter.to.label }}
                                el-date-picker(
                                    v-model='dateFiltersVModelToValues[dateFilter.key]',
                                    @change='handleToDate(dateFilter.key, $event)',
                                    type='date',
                                    :default-value="dateFilter.to.defaultValue"
                                    :placeholder='dateFilter.to.placeholder',
                                    :picker-options='{disabledDate: (time) => disabledpickerOptionsToDate(time,dateFilter.key)}'
                                )        
            
                .filter-item.filter-status.filter-item-wrapper.l-flex-row(v-if="showPartnersFilter")
                    .filter-item.filter-status(v-if="showPartnersFilter")
                        .filter-label
                            svg-icon(name='filter', size='small')
                            .filter-text Partners
                        el-select.filter-partners(
                            v-model="partnersValue"
                            @change="handlePartners($event)"
                            multiple
                            filterable
                            default-first-option
                            size="mini"
                            placeholder="Filter by partners"
                        )
                            el-option(
                                v-for="item in partnerList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.label"
                            )

            .filter-item.search-filters-reset(
                v-if='showReset'
                @click='handleFilter("reset")'
            )
                svg-icon(name='reload', size='small', title='reset filters', @click.native='handleFilter("reset")')
</template>

<script>
import WMultiselect from './Multiselect'
import WSearchable from './Searchable'

import { mapState } from 'vuex'
import dayjs from 'dayjs'

export default {
    components: { WMultiselect, WSearchable },
    props: {
        filters: { type: Array, default: () => [] },
        updateFilter: { type: Function, default: () => ({}) },
        resetFilters: { type: Function, default: () => ({}) },
        dateFilters: { type: Array, default: () => [] },
        updateDate: { type: Function, default: () => ({}) },
        filterDateOperators: { type: Array, default: () => [] },
        updateDateOperator: { type: Function, default: () => ({}) },
        displayTo: { type: Object, default: () => ({}) },
        activeFilters: { type: Object, default: () => ({}) },
        searchResults: { type: Object, default: () => ({}) },
        showPartnersFilter: { type: Boolean, default: false },
        showReset: Boolean
    },

    computed: {
        // Call to state
        ...mapState('data/dsp', {
            dspList: state => state.list
        }),

        partnerList() {
            const partners = []
            this.dspList.forEach(partner => {
                partners.push({
                    label: partner.label,
                    value: partner.keyLabel
                })
            })
            return [...partners, { value: 'Pixel URL', label: 'Pixel URL' }]
        }
    },

    watch: {
        dateFilters: {
            handler: function() {
                if (Object.keys(this.operators).length === 0) this.setOperators()
                if (Object.keys(this.dateFiltersVModelFromValues).length === 0) this.setFromDates()
                if (Object.keys(this.dateFiltersVModelToValues).length === 0) this.setToDates()
            },
            deep: true,

        }
    },

    mounted() {
        if (this.dateFilters) {
            if (Object.keys(this.operators).length === 0) this.setOperators()
            if (Object.keys(this.dateFiltersVModelFromValues).length === 0) this.setFromDates()
            if (Object.keys(this.dateFiltersVModelToValues).length === 0) this.setToDates()
        }
        if (this.filters && Object.keys(this.filterTarget).length === 0) {
            this.setFilterTarget()
        }
    },

    data() {
        return {
            activeMenu: '',
            filterTarget: {},
            operators: {},
            dateFiltersVModelFromValues: {},
            dateFiltersVModelToValues: {},
            openedFilter: '',
            displayFilters: false,
            partnersValue: []
        }
    },

    methods: {
        //- single select filters
        async handleFilter(action, filter) {
            let _params
            if (action === 'update') {
                if (filter.type === 'singleSelect') {
                    _params = { key: filter.key, value: this.filterTarget[filter.key] }
                } else {
                    _params = filter
                }
                await this.$emit('updateFilter', _params)
            } else if (action === 'reset') {
                this.resetData()
                await this.$emit('resetFilters')
            }
        },
        setFilterTarget() {
            for (const _filter in this.filters) {
                const filter = this.filters[_filter]
                this.filterTarget = { ...this.filterTarget, [filter.key]: '' }
            }
        },
        resetData() {
            this.setFilterTarget()
            this.setOperators()
            this.setFromDates()
            this.setToDates()
            this.resetPartners()
        },

        //- multi select && searchable
        handleClick(key) {
            this.openedFilter = this.openedFilter === key ? null : key
        },
        closeSelection() {
            this.openedFilter = null
        },
        handleTermToResearch(researchTerm) {
            this.$emit('termToResearch', researchTerm)
        },

        //- date filters
        async handleDateFilterOperator(filterKey, event) {
            this.operators[filterKey] = event.target.value
            if(this.dateFiltersVModelToValues[filterKey] !== ''
                || this.dateFiltersVModelToValues[filterKey] !== null) {
                this.dateFiltersVModelToValues[filterKey] = ''
            }
            await this.$emit('updateDateOperator', filterKey, this.operators[filterKey])
        },
        async handleFromDate(filterKey, event) {
            this.dateFiltersVModelFromValues[filterKey] = event
            await this.$emit('updateDate', filterKey, 'from', this.dateFiltersVModelFromValues[filterKey])
        },
        async handleToDate(filterKey, event) {
            this.dateFiltersVModelToValues[filterKey] = event
            await this.$emit('updateDate', filterKey, 'to', this.dateFiltersVModelToValues[filterKey])
        },
        async handlePartners(event) {
            await this.$emit('updatePartners', event)
        },

        setOperators() {
            for (const _filter in this.dateFilters) {
                const filter = this.dateFilters[_filter]
                this.operators = {
                    ...this.operators,
                    [filter.key]: 'equal'
                }
            }
        },
        setFromDates() {
            for (const _filter in this.dateFilters) {
                const filter = this.dateFilters[_filter]
                this.dateFiltersVModelFromValues = {
                    ...this.dateFiltersVModelFromValues,
                    [filter.key]: filter.dates.from
                }
            }
        },
        setToDates() {
            for (const _filter in this.dateFilters) {
                const filter = this.dateFilters[_filter]
                const dates = {
                    filterCreatedDate :  new Date().getTime(),
                    filterStartDate: dayjs(filter.dates.to).add(90, 'day').valueOf(),
                    filterEndDate: dayjs(filter.dates.to).add(120, 'day').valueOf(),
                }
                this.dateFiltersVModelToValues = {
                    ...this.dateFiltersVModelToValues,
                    [filter.key]: dates[filter.key]
                }
            }
        },
        // Display filters
        toggleDisplayFilters() {
            this.displayFilters = !this.displayFilters
            this.$emit('filtersBlockDisplayed', this.displayFilters)
        },
        resetPartners() {
            this.handlePartners([])
            this.partnersValue = []
        },
        disabledpickerOptionsFromDate(time, key) {
            const monthMaxByKey = key === 'filterStartDate' ? 90 : 120
            const todayDateTime = key === 'filterCreatedDate'
                ? dayjs().valueOf() : dayjs().add(monthMaxByKey, 'days').startOf('day').valueOf()
            const pickerDateTime = time.getTime()
            const dateTo = this.dateFiltersVModelToValues[key] ? new Date(this.dateFiltersVModelToValues[key]).getTime() : null
            if(dateTo) {
                // here we disable pickerDate only for created and activationDate
                if (key === 'filterCreatedDate') return pickerDateTime > dateTo
                else return pickerDateTime > todayDateTime || pickerDateTime > dateTo
            }
            // here we disable pickerDate only for created and activationDate when we dont have dateTo
            return pickerDateTime > todayDateTime || pickerDateTime < dateTo
        },
        disabledpickerOptionsToDate(time, key) {
            this.dateFiltersVModelToValues[key] = this.dateFiltersVModelToValues[key]
            const monthMaxByKey = key === 'filterStartDate' ? 90 : 120
            const todayDateTime = key === 'filterCreatedDate'
                ? new Date().getTime() : dayjs().add(monthMaxByKey, 'days').startOf('day').valueOf()
            if(key === 'filterStartDate' && this.dateFiltersVModelFromValues[key]) {
                if(new Date(this.dateFiltersVModelFromValues[key]).getTime() === dayjs().add(monthMaxByKey, 'days').startOf('day').valueOf()) {
                    this.dateFiltersVModelFromValues[key]
                }
            }
            if (key === 'filterCreatedDate') {
                return time.getTime() < new Date(this.dateFiltersVModelFromValues[key]).getTime() || time.getTime() > Date.now()
            }
            return time.getTime() < new Date(this.dateFiltersVModelFromValues[key]).getTime() || time.getTime() > todayDateTime
        },
    }, 
}
</script>
